import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//shows signatures of the customer and driver.
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    return (
        <>
        <div className="signature_1_div">
            <div className="row">
                <div className="col text-center signature_1">
                    <b className="sign_1_headings">MUST SIGN BEFORE LOADING → </b>
                </div>
                <div className="col signature_1">
                    <Signature1 heading={"CUSTOMER OR HIS / HER AGENT'S SIGNATURE"}
                                image={IV1_PageDetails.CustomerSign1.Signature}
                                date={IV1_PageDetails.CustomerSign1.UpdatedAt} />
                </div>
                <div className="col">
                    <Signature1 heading={"DRIVER"} image={IV1_PageDetails.DriverSign1.Signature}
                                date={IV1_PageDetails.DriverSign1.UpdatedAt} />
                </div>
            </div>
        </div>
         <div className="terms_text">
             { IV1_PageDetails.Term  ? <> <b>TERMS : </b>{IV1_PageDetails.Term}</> : ""}
         </div>
          <div className="moving_charges_heading">
                <b>MOVING CHARGES</b>
          </div>
      </>
    )
}

const Signature1 = (props) =>{
   return(
       <>
           <p className="sign_1_headings">{props.heading}</p>
           <br/>
           <img src={props.image} className="img-rounded sign_1_image"/>
           <br/>
           <p className="sign_1_date"> {props.date}</p>
       </>
   )
}